import styled from 'styled-components';

export const EmptyCartMessage = styled.h3`
  color: ${Styles.color.black};
  display: flex;
  font-size: 1.125rem;
  font-weight: ${Styles.fontWeight.normal};
  font-family: ${Styles.fontFamily.base};
  justify-content: center;
  padding: 0 0 1rem 0;
`;
